import { useNavigate } from "react-router-dom";
import { Box, IconButton, Link, Stack, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { isMobile } from "../../env";
import { useTheme } from "../../assets/styles/theme";
import { ReferMoneyIcon, ReferShareIcon, ReferSignIcon } from "../../assets/imgs/icons";
import { useUserInfo } from "../../hooks/userInfo";
import { PurpleButton, TextButton } from "../../components/muiCustom/customButton";
import { setTipLogin } from "../../redux/slice/toolSlice";
import { LineGrayInput } from "../../components/muiCustom/customInput";
import { showMessage } from "../../components/messageTip";
import { useEffect, useRef, useState } from "react";
import { useGetAuthUtm, useGetReferStatistics } from "../../redux/productApi";

export default function ReferEarn(){
  const getReferStatistics = useGetReferStatistics();
  const getAuthUtm = useGetAuthUtm();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userInfo = useUserInfo();
  const is_mobile = isMobile();
  const theme = useTheme();

  const [referreds, setReferreds] = useState([
    {name: "Total", name2: "Sign ups", num: 0, keys: "referred_users_count" },
    {name: "Qualified", name2: "Sign ups", num: 0, keys: "referred_users_tiktok_count" },
    {name: "Unpaid", name2: "Earnings", num: 0, keys: "referred_paid" },
    {name: "Paid", name2: "Earnings", num: 0, keys: "referred_unpaid" },
  ])

  const inputRef = useRef<HTMLInputElement>(null)

  const onClose = () => {
    navigate(-1);
  };
  
  const refer_steps = [
    {
      icon: <ReferShareIcon sx={{ fontSize: "0.16rem" }} />,
      name: "Share your unique link"
    }, {
      icon: <ReferSignIcon sx={{ fontSize: "0.16rem" }} />,
      name: "They sign up"
    }, {
      icon: <ReferMoneyIcon sx={{ fontSize: "0.16rem" }} />,
      name: "Your Earn",
      desc: "Receive up to $5 for every qualified creator you refer to Viral Sauce."
    },
  ];

  const copySharesLink = ()=>{
    if(!navigator.clipboard || !navigator.clipboard.writeText){
      showMessage.error("Browser not support"); return;
    }

    const value = inputRef.current?.value || "";

    navigator.clipboard.writeText(value).then(()=>{
      showMessage.success("Copy success");
    }).catch((err)=>{
      showMessage.error("Copy failed");
    })
  };

  const getUtmLink = async ()=>{
    let res_utm = await getAuthUtm({});
    if(res_utm.status_code!== 200 || !res_utm.data){ return; }
    let input = inputRef.current;
    if(input){
      input.value = "www.viralsauce.ai/join/"  + res_utm.data.utm_source
    };
  };

  const getReferData = async ()=>{
    let res = await getReferStatistics({});
    if(res.status_code !== 200 || !res.data){ return; }
    let list = [...referreds];
    list.map(item=>{
      let num = res.data![item.keys] || 0;
      item.num = num;
      return item;
    });
    setReferreds(list);
    
  };

  useEffect(()=>{
    if(userInfo){
      getUtmLink();
      getReferData();
    }
  },[userInfo]);

  return (
    <Stack sx={{
      position: "relative", height: "100%", overflow: "hidden",
    }}>
      <Stack direction="row" sx={{
        p: "0 0.04rem", borderBottom: "0.01rem solid " + theme.palette.grey['25'],
        maxWidth: "650px", width: "100%", m: "0 auto"
      }}>
        <IconButton sx={{p: "0.1rem" }} onClick={onClose}>
          <ArrowBackIosNewIcon sx={{ fontSize: "0.24rem", color: theme.palette.primary['5'] }} />
        </IconButton>
        <Box flexGrow="1" overflow="hidden" p="0 0.2rem 0 0.04rem">
          <Typography sx={{
            textAlign: "center", fontSize: "0.16rem", color: theme.palette.primary['5'],
            lineHeight: "0.44rem",
          }} className="ellipsis">Refer & Earn</Typography>
        </Box>
      </Stack>
      <Box sx={{ flexGrow: 1, overflowX: "hidden", overflowY: "auto" }}>
        <Box sx={{
          p: "0.24rem 0.16rem",
          maxWidth: "650px", width: "100%", m: "0 auto"
        }}>
          <Typography sx={{
            fontSize: "0.2rem", fontWeight: "700",
            textAlign: "center", color: theme.palette.primary['5']
          }}>
            🔥 Invite Creators, Earn Cash
          </Typography>
          <Box sx={{
            color: theme.palette.primary['5'], textAlign: "center",
            mt: "0.05rem"
          }}>
            <Typography sx={{ fontWeight: "400", color: "inherit" }}>
              Help others go viral with ViralSauce and
            </Typography>
            <Typography sx={{ fontWeight: "400", color: "inherit" }}>
              get rewarded for every sign up.
            </Typography>
          </Box>

          <Typography sx={{
            fontSize: "0.18rem", fontWeight: "700", mt: "0.28rem",
            color: theme.palette.primary['5']
          }}>
            💸 How it works
          </Typography>
          <Box sx={{ mt: "0.14rem" }}>
            {refer_steps.map(item=>(
              <Box key={item.name}>
                <Stack direction="row" alignItems="center" gap="0.1rem">
                  <Stack sx={{
                    justifyContent: "center", alignItems: "center",
                    width: "0.26rem", height: "0.26rem",
                    borderRadius: "0.14rem",
                    color: theme.palette.primary['5'],
                    border: "0.01rem solid " + theme.palette.grey['32']
                  }}>
                    {item.icon}
                  </Stack>
                  <Typography sx={{
                    fontSize: "0.16rem", fontWeight: "600",
                    color: theme.palette.primary['5']
                  }}>
                    {item.name}
                  </Typography>
                </Stack>
                <Box sx={{
                  minHeight: "0.16rem", ml: "0.12rem", pl: "0.24rem",
                  borderLeft: "0.01rem solid",
                  borderColor: item.name === "Your Earn" ? "transparent" : theme.palette.grey['32']
                }}>
                  <Typography sx={{
                    fontSize: "0.16rem", fontWeight: "400",
                    color: theme.palette.primary['5']
                  }}>
                    {item.desc}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          <Typography sx={{
            fontSize: "0.18rem", fontWeight: "700", mt: "0.24rem",
            color: theme.palette.primary['5']
          }}>
            🚀 Your Referral Link
          </Typography>
          {userInfo ? (
            <Box>
              <Stack direction="row" mt="0.1rem" gap="0.08rem">
                <LineGrayInput sx={{
                  height: "0.36rem", bgcolor: "transparent",
                  mt: "0", flexGrow: "1", width: "auto",
                  color: theme.palette.primary['5'],
                  borderColor: theme.palette.grey['29']
                }} readOnly ref={inputRef} />
                <PurpleButton sx={{
                  width: is_mobile ? "1rem" : "1.5rem",
                  p: "0", height: "0.36rem", fontSize: "0.14rem"
                }} onClick={copySharesLink}>
                  Copy Link
                </PurpleButton>
              </Stack>
              <Typography sx={{
                fontSize: "0.18rem", fontWeight: "700", mt: "0.16rem",
                color: theme.palette.primary['5']
              }}>
                🎁 Your Stats
              </Typography>
              <Stack direction="row" sx={{
                mt: "0.12rem",
                border: "0.01rem solid " + theme.palette.grey['32']
              }}>
                {referreds.map((item, idx)=>(
                  <Box key={item.name} sx={{
                    p: "0.2rem 0", flex: 1,
                    borderLeft: idx === 0 ? "" : "0.01rem solid " + theme.palette.grey['32']
                  }}>
                    <Typography sx={{
                      fontSize: "0.16rem", fontWeight: "700", textAlign: "center",
                      color: theme.palette.primary['5']
                    }}>
                      {item.num}
                    </Typography>
                    <Stack justifyContent="center" mt="0.12rem">
                      <Typography sx={{
                        fontSize: "0.16rem", fontWeight: "400", textAlign: "center",
                        lineHeight: "0.2rem",
                        color: theme.palette.primary['5']
                      }}>
                        {item.name}
                      </Typography>
                      <Typography sx={{
                        fontSize: "0.16rem", fontWeight: "400", textAlign: "center",
                        lineHeight: "0.2rem",
                        color: theme.palette.primary['5']
                      }}>
                        {item.name2}
                      </Typography>
                    </Stack>
                  </Box>
                ))}
              </Stack>
              <Box sx={{
                mt: "0.16rem", fontSize: "0.12rem",
                color: theme.palette.grey['34']
              }}>
                <Typography component="span" sx={{
                  fontSize: "inherit", color: "inherit"
                }}>
                  Qualified signups are unique individual creators who have signed up, and connected a TikTok account which is active on TikTok shop. Accounts which belong to the same individual do not qualify. See referral
                </Typography> <Link href="/terms" sx={{
                  fontSize: "inherit", color: "inherit"
                }}>program terms</Link> <Typography component="span" sx={{
                  fontSize: "inherit", color: "inherit"
                }}>for more information.</Typography>
                
              </Box>
            </Box>
          ) : (
            <Box mt="0.12rem">
              <Typography sx={{
                fontSize: "0.16rem", fontWeight: "700",
                color: theme.palette.primary['5']
              }}>
                Create an account to get your referral link
              </Typography>
              <PurpleButton sx={{
                width: "100%", mt: "0.2rem",
                maxWidth: is_mobile ? "100%" : "300px"
              }} onClick={()=> dispatch(setTipLogin("register")) }>
                Create account for Free
              </PurpleButton>
              <Stack direction="row" justifyContent="center"
                sx={{
                  mt: "0.16rem", width: "100%", gap: "0.1rem",
                  maxWidth: is_mobile ? "100%" : "300px"
                }}>
                <Typography sx={{ color: theme.palette.primary['4'] }}>
                  Already have an account?
                </Typography>
                <TextButton sx={{ color: theme.custom.txt_3 }}
                  onClick={()=> dispatch(setTipLogin("login")) }>
                  Log In
                </TextButton>
              </Stack>
            </Box>
          )}

        </Box>
      </Box>
    </Stack>
  )
}